import { ref } from 'vue';

/**
 * Abrir e fechar a busca global.
 *
 * POR QUE UM ESTADO FORA DO COMPONENTE
 * ------------------------------------
 * Dois lugares mandam abrir: o campo na barra de cima e o atalho ⌘K, que
 * precisa funcionar em qualquer tela. Se o estado morasse dentro do modal, o
 * campo teria de passar `prop` e o atalho teria de saber onde o modal está
 * montado — e no dia em que aparecesse um terceiro gatilho (o vazio da tela de
 * Processos, por exemplo) cada um teria a sua cópia da regra.
 *
 * `ref` de módulo é o singleton: todo mundo que importa lê e escreve o MESMO
 * valor, e o modal é montado uma vez só, na barra.
 */
const aberta = ref(false);

// O que já estava digitado quando abriram. Serve para o dia em que um gatilho
// quiser abrir já com termo ("procurar por este CPF"), sem inventar outro
// caminho de entrada.
const termoInicial = ref('');

export function useBuscaGlobal() {
  const abrir = (termo = '') => {
    termoInicial.value = termo;
    aberta.value = true;
  };

  const fechar = () => {
    aberta.value = false;
    termoInicial.value = '';
  };

  return { aberta, termoInicial, abrir, fechar };
}

/**
 * O atalho é ⌘K no Mac e Ctrl+K no resto — o mesmo do Spotlight, do VS Code e
 * do Slack, que é onde a pessoa já aprendeu.
 *
 * Fora daqui de propósito: o `keydown` global é registrado num lugar só (a
 * barra), e este helper existe para a decisão "isto é o atalho?" não ser
 * reescrita com uma condição a menos em outro lugar.
 */
export const ehAtalhoDeBusca = evento =>
  (evento.metaKey || evento.ctrlKey) &&
  String(evento.key).toLowerCase() === 'k';
